import * as React from "react";
import { ResponsiveBar, BarDatum } from '@nivo/bar';
import { roundToTop, createRange } from "../../../misc/math-functions";
import { BoxLegendSvg } from "@nivo/legends";

interface VolumeGraphProps {
    data: BarDatum[];
    maxVolume: number;
}


function compileTestNumbers(data: BarDatum[]): number[] {
    let keys = [];
    for (let dataItem of data) {
        keys.push(dataItem.id + '');
    }
    return keys;
}

const BarLegend = ({ height, legends, width }) => (
    <React.Fragment>
        {legends.map(legend => (
            <BoxLegendSvg
                key={JSON.stringify(legend.data.map(({ id }) => id))}
                {...legend}
                containerHeight={height}
                containerWidth={width}
            />
        ))}
    </React.Fragment>
);


export const SvcVolumeGraph = ({ data, maxVolume }: VolumeGraphProps ) => {

    const testIndexValues = compileTestNumbers(data);
    const yTicks = createRange(0, roundToTop(maxVolume) + 1, 1);
    
    return (
        <ResponsiveBar
        data={data}
        keys={["value"]}
        indexBy={_index => { return _index.id }}
        key="key"
        margin={{ top: 30, right: 160, bottom: 50, left: 60 }}
        colors={d => d.data.color }
        padding={0.6}
        axisTop={null}
        groupMode="grouped"
        axisRight={null}
        layers={["grid", "axes", "bars", "markers", BarLegend]}
        axisBottom={{
            tickValues: testIndexValues,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Tests',
            legendOffset: 30,
            legendPosition: 'middle'
        }}
        axisLeft={{
            tickValues: yTicks,
            tickSize: 1,
            tickPadding: 1,
            tickRotation: 0,
            legend: 'Volume (L)',
            legendOffset: -40,
            legendPosition: 'middle'
        }}
        tooltip={(p) => {
            return <div className="lineChartTooltip">
                <span className="lineChartTooltipIcon" style={{ background: p.color }}></span>
                <span>Volume: <strong>{p.value}</strong></span>
            </div>
        }}
        legends={[
            {
                dataFrom: 'indexes',
                anchor: 'top',
                direction: 'row',
                justify: false,
                translateX: 10,
                translateY: -30,
                itemsSpacing: 2,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 30,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'square',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                data: testIndexValues.map((id, index) => ({
                    color: data[index].color + '',
                    id,
                    label: `Test ${id}`
                })),
            }
        ]}
        isInteractive={true}
        gridXValues={testIndexValues}
        gridYValues={yTicks}
    />);
}
